export default __webpack_public_path__ + "media/images/logo-dark-d4df9a912413ac5c68db8ef2aae6abb0.svg";